<template>
  <v-dialog
    :value="value"
    persistent
    max-width="50rem">
    <v-card>
      <v-card-text>
        <v-form v-model="valid">
          <v-container grid-list-md>
            <v-layout>
              <v-flex>
                <v-text-field
                  v-model="edited.name"
                  :rules="[v => !!v || 'Name is required']"
                  label="Name"/>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex lg6>
                <v-text-field
                  v-model="edited.lat"
                  :rules="[
                    v => !Number.isNaN(parseFloat(v)) || !v ||
                      'Latitude must be a number',
                    v => Number.isNaN(parseFloat(v)) ||
                      parseFloat(v) <= 90 && parseFloat(v) >= -90 ||
                      'Out of bounds',
                    v => Number.isNaN(parseFloat(v)) ||
                      parseFloat(v).toFixed(6).length >= String(v).length ||
                      'Precision is too high'
                  ]"
                  label="Latitude"/>
              </v-flex>
              <v-flex lg6>
                <v-text-field
                  v-model="edited.lng"
                  :rules="[
                    v => !Number.isNaN(parseFloat(v)) || !v ||
                      'Longitude must be a number',
                    v => Number.isNaN(parseFloat(v)) ||
                      parseFloat(v) <= 180 && parseFloat(v) >= -180 ||
                      'Out of bounds',
                    v => Number.isNaN(parseFloat(v)) ||
                      parseFloat(v).toFixed(6).length >= String(v).length ||
                      'Precision is too high'
                  ]"
                  label="Longitude"/>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          :disabled="posting"
          flat
          @click="$emit('input', false)">
          Cancel
        </v-btn>
        <v-btn
          :disabled="posting || !valid"
          flat
          @click="save">
          <v-progress-circular
            v-if="posting"
            indeterminate/>
          <span v-else>Save</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "edit-dialog",
  props: {
    franchise: {
      required: true,
      type: Object
    },
    value: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      edited: {},
      posting: false,
      valid: false
    };
  },
  watch: {
    value (newValue) {
      if (newValue === true) {
        this.edited = Object.assign({}, this.franchise);
      }
    }
  },
  methods: {
    save () {
      this.posting = true;
      this.$http.
        put(
          `/api/franchises/${this.$route.params.id}`,
          {
            lat: this.edited.lat,
            lng: this.edited.lng,
            name: this.edited.name
          }
        ).
        then(() => {
          this.posting = false;
          this.$emit("input", false);
          this.$emit("refresh");
        }).
        catch(() => this.posting = false);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Franchise/EditDialog.vue